/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../SlotDefinitionAPI'
], (APIFactory, SlotDefinitionAPI) => {
	class SlotDefinitionImpl  {
		constructor(slotDefinition) {
			this.slotDefinition = slotDefinition;
		}

		destroy() {
			this.slotDefinition = null;
		}

		getProperty(id) {
			return this.slotDefinition[id];
		}

		getAPI() {
			return APIFactory.createAPI(this, [SlotDefinitionAPI]);
		}

		getDatasetIdList() {
			return this.slotDefinition.datasetIdList;
		}

		getId() {
			return this.slotDefinition.id;
		}

		getType() {
			return this.slotDefinition.type;
		}

		getSubType() {
			return this.slotDefinition.subtype;
		}

		getCaption() {
			return this.slotDefinition.caption;
		}

		getIcon() {
			return this.slotDefinition.icon;
		}

		getGroupId() {
			return this.slotDefinition.group;
		}

		getRole() {
			return this.slotDefinition.role;
		}

		isHidden() {
			return this.slotDefinition.hidden || false;
		}

		isOptional() {
			return this.slotDefinition.optional || false;
		}

		getSort() {
			return this.slotDefinition.sort;
		}

		getSortOrder() {
			return this.slotDefinition.sortOrder;
		}

		getAggregatedSortInfo() {
			return this.slotDefinition.clientSideAggregatedAndSortInfo;
		}

		isSortable() {
			return this.slotDefinition.sortable || false;
		}

		isStackItems() {
			return this.slotDefinition.stackItems || false;
		}

		getMaxItems() {
			return this.slotDefinition.maxItems === undefined ?  this.slotDefinition.maxStackItems : this.slotDefinition.maxItems;
		}

		isMultiMeasureSupported() {
			return this.slotDefinition.multiMeasure || false;
		}

		isShapable() {
			return this.slotDefinition.shapable || false;
		}

		getCoachMark() {
			return this.slotDefinition.coachMark;
		}

		getFormat() {
			return this.slotDefinition.format;
		}

		getTags() {
			return this.slotDefinition.tags;
		}

		getDefaultFromSlot() {
			return this.slotDefinition.defaultFromSlot;
		}

		getShowRequiredMarker() {
			return this.slotDefinition.showRequiredMarker === false ? false : true;
		}
	}

	return SlotDefinitionImpl;
});
